import React, {Component} from 'react'
import {Label, Input} from 'reactstrap'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {withApollo} from 'react-apollo'

class FilterWeldersSwitch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      switch_on: localStorage.getItem('weldsGridFilterWelders') === 'true'
    }

    this.handleSwitch = this.handleSwitch.bind(this)
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    weld_id: PropTypes.number.isRequired,
    updateWeldersData: PropTypes.func.isRequired,
  }

  componentWillMount() {
    this.state.switch_on && this.fetchWeldersData()
  }

  handleSwitch() {
    this.setState({switch_on: !this.state.switch_on}, () => {
      if (this.state.switch_on) {
        this.fetchWeldersData()
      } else {
        this.props.updateWeldersData(null)
      }
    })
  }

  fetchWeldersData() {
    this.props.client.query({
      query: WeldersFetchQuery,
      fetchPolicy: 'network-only',
      variables: {weld_id: this.props.weld_id}
    }).then(({data}) => {
      this.props.updateWeldersData(data.welders_by_weld)
    })
  }

  render() {
    return (
      <div style={{fontWeight: 400}} className="float-right">
        &nbsp; Filter by qualifications &nbsp;
        <Label id="show-welders-switch" className="switch switch-sm switch-text switch-info mb-0">
          <Input type="checkbox" className="switch-input"
            checked={this.state.switch_on}
            onChange={this.handleSwitch}/>
          <span className="switch-label" data-on="On" data-off="Off"/>
          <span className="switch-handle"/>
        </Label>
      </div>
    )
  }
}

const WeldersFetchQuery = gql`
  query WeldersFetchQuery($weld_id: Int!) {
    welders_by_weld(weld_id: $weld_id) {
      id 
      name
    }
  }
`

export default withApollo(FilterWeldersSwitch)



// WEBPACK FOOTER //
// ./src/components/EventLog/helpers/FilterWeldersSwitch.js